import { parsePhoneNumberFromString } from "libphonenumber-js";

const DISALLOWED_PHONE_CHARS = /[^0-9+ ]/g;

export function cleanPhoneInput(value) {
  if (value == null) {
    return value;
  }

  return String(value).replace(DISALLOWED_PHONE_CHARS, "");
}

export function normalizePhoneToE164(value, defaultCountry = "CH") {
  const cleaned = cleanPhoneInput(value);

  if (cleaned == null || cleaned.trim() === "") {
    return "";
  }

  const phoneNumber = parsePhoneNumberFromString(cleaned, defaultCountry);

  if (!phoneNumber || !phoneNumber.isValid()) {
    throw new Error("Invalid phone number");
  }

  return phoneNumber.number;
}

export function isValidPhone(value, defaultCountry = "CH") {
  if (value == null || String(value).trim() === "") {
    return true;
  }

  if (cleanPhoneInput(value) !== String(value)) {
    return false;
  }

  try {
    normalizePhoneToE164(value, defaultCountry);
    return true;
  } catch (e) {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/utils/phone.js